import { WidgetsAbstract } from "../widgets/widgets.abstract";

export abstract class CommandActionAsync {
    undo() {
        throw new Error("Function not implemented.");
    }
    redo() {
        throw new Error("Function not implemented.");
    }

    abstract executeAsync(parent:WidgetsAbstract, widget:WidgetsAbstract|undefined): Promise<any>;
}
